module.exports = __webpack_public_path__ + "static/media/udemy.988aee0a.jpg";